import { buildMailtoLink } from '@agilox/common';
import { UIThemes } from '@agilox/ui-common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '@agilox/ui';

const RENEWAL_MAIL_RECIPIENT = 'internalsales@agilox.net';
const RENEWAL_MAIL_SUBJECT_KEY = 'general.subscription_renewal.mail_subject';
const RENEWAL_MAIL_BODY_KEY = 'general.subscription_renewal.mail_body';

@Component({
	selector: 'subscription-renewal-button',
	templateUrl: './subscription-renewal-button.component.html',
	imports: [ButtonComponent, TranslateModule],
})
export class SubscriptionRenewalButtonComponent {
	private translate = inject(TranslateService);

	userEmail = input<string>('');
	userName = input<string>('');

	renewalMailtoLink = computed(() =>
		buildMailtoLink(
			RENEWAL_MAIL_RECIPIENT,
			this.translate.instant(RENEWAL_MAIL_SUBJECT_KEY),
			this.translate.instant(RENEWAL_MAIL_BODY_KEY, {
				name: this.userName(),
				email: this.userEmail(),
			})
		)
	);

	protected readonly UIThemes = UIThemes;
}
